'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState, useRef } from 'react'

export function Providers({ children }: { children: React.ReactNode }) {
  // Create a ref to store QueryClient and initialize it only once
  const queryClientRef = useRef<QueryClient | null>(null)
  if (!queryClientRef.current) {
    queryClientRef.current = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 60 * 1000, // 1 minute
          refetchOnWindowFocus: false,
        },
      },
    })
  }

  // The QueryClientProvider expects a QueryClient instance, not null.
  // The `if` block above ensures queryClientRef.current is initialized.
  // However, to satisfy TypeScript, we need to assert it's not null here or handle the null case.
  // Given the logic, it will always be initialized.
  return (
    <QueryClientProvider client={queryClientRef.current!}>
      {children}
    </QueryClientProvider>
  )
} 